/**
 * Formats citation anchor tags in HTML for card display.
 *
 * Detects citation links (text content is `[N]` or `N` where N is digits),
 * adds the `ask-klue-citation` class for badge styling, and strips brackets
 * from legacy `[N]` format.
 *
 * Uses a loop-based parser instead of regex to avoid a ReDoS vulnerability
 * (redos/no-vulnerable) and to handle `<a>` tags with variable attributes
 * (e.g. target, rel) in any order.
 */
const CITATION_CONTENT_RE = /^\[?(\d+)\]?$/;

const formatCardCitations = (html: string): string => {
  let result = '';
  let pos = 0;

  while (pos < html.length) {
    const tagStart = html.indexOf('<a ', pos);
    if (tagStart === -1) break;

    const openClose = html.indexOf('>', tagStart);
    const tagClose = html.indexOf('</a>', tagStart);
    if (openClose === -1 || tagClose === -1 || openClose >= tagClose) {
      result += html.slice(pos, tagStart + 3);
      pos = tagStart + 3;
      continue;
    }

    const tagEnd = tagClose + 4;
    const attrs = html.slice(tagStart + 3, openClose);
    const content = html.slice(openClose + 1, tagClose);
    const numMatch = CITATION_CONTENT_RE.exec(content);

    if (attrs.includes('href=') && numMatch) {
      result += html.slice(pos, tagStart);
      if (result.length > 0 && !/\s/.test(result[result.length - 1])) {
        result += ' ';
      }
      result += `<a ${attrs} class="ask-klue-citation">${numMatch[1]}</a>`;
    } else {
      result += html.slice(pos, tagEnd);
    }

    pos = tagEnd;
  }

  result += html.slice(pos);
  return result;
};

export { formatCardCitations };
